import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-new */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useRef } from 'react';
import { AppRoot, SplitLayout, SplitCol, View, ModalRoot, ModalPage, ModalPageHeader, PanelHeaderButton, Div, Epic, Tabbar, TabbarItem, FormItem, Input, Button, SimpleCell, Textarea, Snackbar, NativeSelect, ScreenSpinner, PanelHeader, FormLayoutGroup, IconButton, File, Avatar } from '@vkontakte/vkui';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Icon24Dismiss, Icon24Document, Icon28CancelCircleFillRed, Icon28CheckCircleFill, Icon28DeleteOutline, Icon28DoorArrowRightOutline, Icon28SettingsOutline, Icon28Users3Outline } from '@vkontakte/icons';
import { VldBuilder, vlds } from 'validatorus-react';
import QRCodeStyling from 'qr-code-styling';
import '@vkontakte/vkui/dist/vkui.css';
import './style.css';
// import logo from './img/logo.svg'
import { useTranslation } from 'react-i18next';
import { Main } from './pages/main';
import { LoginPage } from './pages/login';
import { Merchant } from './pages/merchant';
import { Settings } from './pages/settings';
import { Error } from './pages/500';
import { MenuPage } from './pages/menu';
import { NewApi } from './logic/api';
import { HeaderBlock } from './layout/header';
import * as QRoptions from './qr.json';
import { Translate } from './logic/lang';
const ipfs = 'https://cloudflare-ipfs.com/ipfs/';
const options = QRoptions;
const qrCode = new QRCodeStyling(options);
// const trans: Translate = new Translate().a()
export const App = () => {
    const [activeModal, setActiveModal] = React.useState(null);
    const [snackbar, setSnackbar] = React.useState(null);
    const [popout, setPopout] = React.useState(null);
    const [firstRender, setFirstRender] = React.useState(false);
    const [loginPage, setLoginPage] = React.useState(false);
    const [auth, setAuth] = React.useState(0);
    const [selectMerhant, setSelectMerhant] = React.useState(undefined);
    const [userInfo, setUserInfo] = React.useState(undefined);
    const [categoryList, setCategoryList] = React.useState(undefined);
    const [errorText, setErrorText] = React.useState(undefined);
    const [file, setFile] = React.useState(undefined);
    const [oneMenu, setOneMenu] = React.useState(undefined);
    const [isDesktop, setIsDesktop] = React.useState(window.innerWidth >= 1200);
    const { t, i18n } = useTranslation('common');
    const ref = useRef(null);
    const location = useLocation();
    const history = useNavigate();
    // const trans: React.MutableRefObject<Translate> = useRef(new Translate())
    const newApi = new NewApi();
    function openPop() {
        setPopout(_jsx(ScreenSpinner, { state: "loading" }));
    }
    function closePop(type) {
        if (type)
            setPopout(_jsx(ScreenSpinner, { state: "done", "aria-label": "Success" }));
        else
            setPopout(_jsx(ScreenSpinner, { state: "error", "aria-label": "Error" }));
        setTimeout(() => {
            setPopout(null);
        }, 1000);
    }
    const full_name_category = new VldBuilder()
        .with(vlds.VLen, 4, 128)
        .withFname(t('category_name'));
    const full_name_menu = new VldBuilder()
        .with(vlds.VLen, 4, 128)
        .withFname(t('position_name'));
    const full_desc_menu = new VldBuilder()
        .with(vlds.VLen, 4, 512)
        .withFname(t('position_description'));
    const price = new VldBuilder()
        .with(vlds.VNumber, 0.01, 10000)
        .withFname(t('position_price'));
    const img = new VldBuilder()
        .with(vlds.VLen, 1, 512)
        .withFname(t('img'));
    const category = new VldBuilder()
        .with(vlds.VNumber, 0, 100000)
        .withFname(t('category'));
    const full_name = new VldBuilder()
        .with(vlds.VLen, 4, 128)
        .withFname(t('restourant_name'));
    const full_desc = new VldBuilder()
        .with(vlds.VLen, 4, 512)
        .withFname(t('restourant_description'));
    const phone = new VldBuilder()
        .with(vlds.VLen, 3, 20)
        .withFname(t('restourant_phone'));
    const address = new VldBuilder()
        .with(vlds.VLen, 3, 128)
        .withFname(t('restourant_address'));
    const time_work = new VldBuilder()
        .with(vlds.VLen, 3, 20)
        .withFname(t('restourant_work time'));
    const wifi = new VldBuilder()
        .with(vlds.VLen, 2, 64)
        .withFname(t('restourant_wifi name'));
    const email_input = new VldBuilder()
        .with(vlds.VEmail)
        .withFname(t('restourant_email'));
    const site = new VldBuilder()
        .with(vlds.VDomain)
        .withFname(t('restourant_site'));
    const instagram = new VldBuilder()
        .with(vlds.VLen, 3, 256)
        .withFname(t('restourant_instagram'));
    const telegram = new VldBuilder()
        .with(vlds.VLen, 3, 256)
        .withFname(t('restourant_telegram'));
    const type_res = new VldBuilder()
        .with(vlds.VLen, 3, 256)
        .withFname(t('restourant_type'));
    const logo = new VldBuilder()
        .with(vlds.VLen, 3, 256)
        .withFname(t('restourant_logo'));
    const inputDel = new VldBuilder()
        .with(vlds.VLen, 3, 256)
        .withFname(t('restourant_name'));
    async function logOut() {
        setAuth(1);
        setLoginPage(true);
        history('/');
        newApi.logOut();
        // clearToken()
    }
    function consoleLog(data, type = false) {
        setSnackbar(_jsx(Snackbar, { before: type ? _jsx(Icon28CheckCircleFill, {}) : _jsx(Icon28CancelCircleFillRed, {}), onClose: () => setSnackbar(null), children: data }));
    }
    function onErrorApi(resp) {
        if (!resp) {
            // logOut()
            closePop(false);
            return false;
        }
        if (!resp || resp.code !== 200) {
            if (resp.code === 3004) { // webhook history
                return false;
            }
            if (resp.code === 1002) {
                logOut();
                closePop(false);
                return false;
            }
            if (resp.code === 500) {
                setErrorText(resp.message);
                history('/500');
                closePop(false);
                setActiveModal(null);
                return false;
            }
            if (resp) {
                const respA = resp;
                if (respA.code) {
                    consoleLog(`#${respA.code} ${respA.message}`, false);
                }
                else {
                    return true;
                }
            }
            else {
                consoleLog('error undefind', false);
            }
            closePop(false);
            return false;
        }
        return true;
    }
    async function loginUser(email, psw) {
        openPop();
        // const resp = await api.user.login({ email })
        // if (resp.status !== 'ok') {
        //     console.log('status not ok:', resp)
        //     consoleLog(resp.desc)
        //     closePop(false)
        //     return false
        // }
        const resp = await newApi.sendEmailCode(email, psw);
        if (!onErrorApi(resp))
            return false;
        closePop(true);
        console.log(resp);
        return true;
    }
    async function getUser() {
        const resp = await newApi.getMe();
        if (!onErrorApi(resp))
            return false;
        console.log(resp);
        setUserInfo(resp);
        // setActiveModal(null)
        return true;
    }
    async function createMerchant() {
        const resp = await newApi.createRestourant(full_name.value, full_desc.value, phone.value, address.value, time_work.value, wifi.value, email_input.value, site.value, instagram.value, telegram.value, type_res.value, logo.value);
        if (!onErrorApi(resp))
            return false;
        console.log(resp);
        consoleLog('Successfull create Restourant', true);
        // changeFormData(resp)
        history('/');
        history('/restourants');
        setActiveModal(null);
        return true;
    }
    async function createCategory() {
        if (!selectMerhant) {
            return false;
        }
        const resp = await newApi.createCategory(selectMerhant.id, full_name_category.value);
        if (!onErrorApi(resp))
            return false;
        console.log(resp);
        consoleLog('Successfull create Category', true);
        // changeFormData(resp)
        // history('/restourants')
        setActiveModal(null);
        return true;
    }
    async function createPosition() {
        if (!selectMerhant) {
            return false;
        }
        const resp = await newApi.createPosition(selectMerhant.id, Number(category.value), full_name_menu.value, full_desc_menu.value, price.value, logo.value);
        if (!onErrorApi(resp))
            return false;
        console.log(resp);
        consoleLog('Successfull create Position', true);
        // changeFormData(resp)
        history('/restourants');
        history(`/restourant/${selectMerhant.id}`);
        setActiveModal(null);
        return true;
    }
    async function gelMerchant() {
        if (selectMerhant) {
            // const resp = await newApi.merchantDel(selectMerhant.id)
            // if (!onErrorApi(resp)) return false
            // console.log(resp)
            // history('/merchants')
            // setActiveModal(null)
            // consoleLog('Successfull delited merchant', true)
            // setActiveModal(null)
            return true;
        }
        return false;
    }
    async function getCategory() {
        if (!selectMerhant) {
            return false;
        }
        const resp = await newApi.getCategory(selectMerhant.id);
        if (!onErrorApi(resp))
            return false;
        console.log(resp);
        const respType = resp;
        setCategoryList(respType.categorys);
        // setActiveModal(null)
        return true;
    }
    async function updateMenu() {
        if (!oneMenu || !selectMerhant) {
            return false;
        }
        const resp = await newApi.updatePosition(oneMenu.id, Number(category.value), full_name_menu.value, full_desc_menu.value, price.value, logo.value);
        if (!onErrorApi(resp))
            return false;
        consoleLog('Successfull update Position', true);
        history('/restourants');
        history(`/restourant/${selectMerhant.id}`);
        setActiveModal(null);
        return true;
    }
    async function uploadImg(e) {
        const _file = e.target.files[0];
        console.log(_file);
        setFile(_file);
        const url = await newApi.infuraUploadImg(_file);
        logo.change(url ?? '');
        return url;
    }
    useEffect(() => {
        window.addEventListener('resize', () => setIsDesktop(window.innerWidth >= 1200));
    }, [window.innerWidth]);
    useEffect(() => {
        if (!firstRender) {
            setFirstRender(true);
            const au = newApi.checkAuth();
            if (location.pathname.indexOf('/menu') === -1) {
                if (au) {
                    setAuth(2);
                    if (location.pathname === '/') {
                        history('/restourants');
                    }
                }
                else {
                    logOut();
                }
            }
            const tr = new Translate();
            i18n.changeLanguage(tr.getLang());
            // setTrans(new Translate())
            // trans = new Translate()
            // qrCode.append(ref.current ?? undefined)
            // checkAuth()
        }
    }, []);
    useEffect(() => {
        if (selectMerhant) {
            console.log('changed', selectMerhant);
        }
    }, [selectMerhant, activeModal]);
    useEffect(() => {
        if (activeModal === null) {
            inputDel.reset(true, true);
            full_name.reset(true, true);
            full_desc.reset(true, true);
            phone.reset(true, true);
            address.reset(true, true);
            time_work.reset(true, true);
            wifi.reset(true, true);
            email_input.reset(true, true);
            site.reset(true, true);
            instagram.reset(true, true);
            telegram.reset(true, true);
            type_res.reset(true, true);
            logo.reset();
            img.reset(true, true);
            price.reset(true, true);
            full_desc_menu.reset(true, true);
            full_name_menu.reset(true, true);
            full_name_category.reset(true, true);
            category.change('0');
        }
        if (activeModal === 'category_list' || activeModal === 'create_menu') {
            getCategory();
        }
        if (activeModal === 'update_menu' && oneMenu) {
            getCategory();
            img.change(oneMenu.img);
            price.change(oneMenu.price);
            full_desc_menu.change(oneMenu.full_desc);
            full_name_menu.change(oneMenu.full_name);
            category.change(oneMenu.id_categorys.toString());
        }
        if (activeModal === 'qr' && selectMerhant) {
            const node = document.querySelector('.vkuiPopoutRoot__modal');
            const config = { attributes: true, childList: true, subtree: true };
            const observer = new MutationObserver((e, ob) => {
                if (ref.current) {
                    qrCode.append(ref.current ?? undefined);
                    ob.disconnect();
                }
            });
            // Start observing the target node for configured mutations
            if (node)
                observer.observe(node, config);
        }
        if (activeModal === 'qr2') {
            const node = document.querySelector('.vkuiPopoutRoot__modal');
            const config = { attributes: true, childList: true, subtree: true };
            const observer = new MutationObserver((e, ob) => {
                if (ref.current) {
                    qrCode.append(ref.current ?? undefined);
                    ob.disconnect();
                }
            });
            // Start observing the target node for configured mutations
            if (node)
                observer.observe(node, config);
            qrCode.update({
                data: 'https://qrall.ge'
                // image: selectMerhant.logo ? ipfs + selectMerhant.logo : undefined
            });
        }
    }, [activeModal]);
    useEffect(() => {
        if (selectMerhant) {
            qrCode.update({
                data: `${window.location.origin}/menu/${selectMerhant.id}`,
                image: selectMerhant.logo ? ipfs + selectMerhant.logo : undefined
            });
        }
    }, [selectMerhant]);
    const modalRoot = (_jsxs(ModalRoot, { activeModal: activeModal, children: [_jsx(ModalPage, { id: 'create_merchant', className: "qrall", onClose: () => setActiveModal(null), dynamicContentHeight: true, 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: t('new_restourant') }), children: _jsxs(Div, { children: [_jsx(FormItem, { top: full_name.fname, bottom: full_name.error, children: _jsx(Input, { type: "text", placeholder: t('cafe&bar').toString(), value: full_name.value, onChange: (e) => { full_name.change(e.target.value); }, status: full_name.iserr }) }), _jsx(FormItem, { top: address.fname, bottom: address.error, children: _jsx(Input, { type: "text", placeholder: 'Tbilisi...', value: address.value, onChange: (e) => { address.change(e.target.value); }, status: address.iserr }) }), _jsx(FormItem, { top: logo.fname, children: _jsx(File, { before: _jsx(Icon24Document, { role: "presentation" }), size: "l", onChange: e => uploadImg(e), mode: "secondary", children: file ? file.name : 'choose File' }) }), _jsx(FormLayoutGroup, { children: _jsx(FormItem, { top: full_desc.fname, bottom: full_desc.error, children: _jsx(Textarea, { placeholder: t('few words about restourant').toString(), value: full_desc.value, onChange: (e) => { full_desc.change(e.target.value); }, status: full_desc.iserr }) }) }), _jsx(FormItem, { children: _jsx("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' }, children: _jsx(Button, { size: "l", stretched: true, 
                                    // disabled={!formCreateM}
                                    disabled: !(full_name.iserr === 'valid'
                                        && address.iserr === 'valid'
                                        && full_desc.iserr === 'valid'
                                        && logo.value === ''), onClick: () => {
                                        createMerchant();
                                    }, children: t('create_restourant') }) }) })] }) }), _jsx(ModalPage, { id: 'delete_merchant', className: "qrall", onClose: () => setActiveModal(null), dynamicContentHeight: true, 
                // settlingHeight={100}
                header: _jsxs(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: [t('delete'), " ", selectMerhant?.full_name, "?"] }), children: _jsxs(Div, { children: [_jsx(FormItem, { top: t('to confirm, please enter the name of restourant'), children: _jsx(Input, { type: "text", placeholder: t('restourant_name').toString(), value: inputDel.value, onChange: e => inputDel.change(e.target.value) }) }), _jsx(FormItem, { children: _jsx("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' }, children: _jsxs(Button, { size: "l", stretched: true, disabled: inputDel.value !== selectMerhant?.full_name, onClick: () => {
                                        gelMerchant();
                                    }, children: [t('delete'), " "] }) }) })] }) }), _jsx(ModalPage, { id: 'create_category', className: "qrall", onClose: () => setActiveModal('category_list'), dynamicContentHeight: true, 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal('category_list'), children: _jsx(Icon24Dismiss, {}) })), children: t('new_category') }), children: _jsxs(Div, { children: [_jsx(FormItem, { top: full_name_category.fname, bottom: full_name_category.error, children: _jsx(Input, { type: "text", placeholder: 'Drinks', value: full_name_category.value, onChange: (e) => { full_name_category.change(e.target.value); }, status: full_name_category.iserr }) }), _jsx(FormItem, { children: _jsx("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' }, children: _jsx(Button, { size: "l", stretched: true, 
                                    // disabled={!formCreateM}
                                    disabled: !(full_name_category.iserr === 'valid'), onClick: () => {
                                        createCategory();
                                    }, children: t('create_category') }) }) })] }) }), _jsx(ModalPage, { id: 'category_list', className: "qrall", onClose: () => setActiveModal(null), dynamicContentHeight: true, settlingHeight: 100, header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: t('category_list') }), children: categoryList
                    ? _jsxs(Div, { children: [categoryList.map((c, key) => (_jsx(SimpleCell, { before: _jsxs("span", { style: { marginRight: '16px' }, children: ["#", c.id] }), after: _jsx(IconButton, { children: _jsx(Icon28DeleteOutline, {}) }), children: c.full_name }, key))), _jsx("br", {}), _jsx(Button, { onClick: () => setActiveModal('create_category'), size: "l", stretched: true, children: t('add_category') })] }) : null }), _jsx(ModalPage, { id: 'create_menu', className: "qrall", onClose: () => setActiveModal(null), dynamicContentHeight: true, 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: t('new_position') }), children: categoryList
                    ? _jsxs(Div, { children: [_jsx(FormItem, { top: full_name_menu.fname, bottom: full_name_menu.error, children: _jsx(Input, { type: "text", placeholder: 'Latte...', value: full_name_menu.value, onChange: (e) => { full_name_menu.change(e.target.value); }, status: full_name_menu.iserr }) }), _jsx(FormItem, { top: logo.fname, children: _jsx(File, { before: _jsx(Icon24Document, { role: "presentation" }), size: "l", onChange: e => uploadImg(e), mode: "secondary", children: file ? file.name : 'choose File' }) }), _jsx(FormItem, { top: full_desc_menu.fname, bottom: full_desc_menu.error, children: _jsx(Textarea, { placeholder: 'About...', value: full_desc_menu.value, onChange: (e) => { full_desc_menu.change(e.target.value); }, status: full_desc_menu.iserr }) }), _jsx(FormItem, { top: price.fname, bottom: price.error, children: _jsx(Input, { type: "number", placeholder: '1.0', value: price.value, onChange: (e) => { price.change(e.target.value); }, status: price.iserr }) }), _jsx(FormItem, { top: category.fname, bottom: category.error, children: _jsxs(NativeSelect, { onChange: (e) => { category.change(e.target.value); }, value: category.value, children: [_jsx("option", { value: "0", children: t('default') }), categoryList.map((c, key) => (_jsx("option", { value: c.id, children: c.full_name }, key)))] }) }), _jsx(FormItem, { children: _jsx("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' }, children: _jsx(Button, { size: "l", stretched: true, 
                                        // disabled={!formCreateM}
                                        disabled: !(full_name_menu.iserr === 'valid'
                                            && full_desc_menu.iserr === 'valid'
                                            && price.iserr === 'valid'), onClick: () => {
                                            createPosition();
                                        }, children: t('create_position') }) }) })] }) : null }), _jsx(ModalPage, { id: 'update_menu', className: "qrall", onClose: () => setActiveModal(null), dynamicContentHeight: true, 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: t('edit_position') }), children: categoryList && oneMenu
                    ? _jsxs(Div, { children: [_jsx(FormItem, { top: full_name_menu.fname, bottom: full_name_menu.error, children: _jsx(Input, { type: "text", placeholder: 'Latte...', value: full_name_menu.value, onChange: (e) => { full_name_menu.change(e.target.value); }, status: full_name_menu.iserr }) }), _jsxs(FormLayoutGroup, { mode: "horizontal", children: [_jsx(FormItem, { children: _jsx(Avatar, { src: ipfs + oneMenu.img, size: 72, mode: 'app' }) }), _jsx(FormItem, { top: logo.fname, style: { width: '70%' }, children: _jsx(File, { before: _jsx(Icon24Document, { role: "presentation" }), size: "l", onChange: e => uploadImg(e), mode: "secondary", children: file ? file.name : 'choose File' }) })] }), _jsx(FormItem, { top: full_desc_menu.fname, bottom: full_desc_menu.error, children: _jsx(Textarea, { placeholder: 'About...', value: full_desc_menu.value, onChange: (e) => { full_desc_menu.change(e.target.value); }, status: full_desc_menu.iserr }) }), _jsx(FormItem, { top: price.fname, bottom: price.error, children: _jsx(Input, { type: "number", placeholder: '1.0', value: price.value, onChange: (e) => { price.change(e.target.value); }, status: price.iserr }) }), _jsx(FormItem, { top: category.fname, bottom: category.error, children: _jsxs(NativeSelect, { onChange: (e) => { category.change(e.target.value); }, value: category.value, children: [_jsx("option", { value: "0", children: t('default') }), categoryList.map((c, key) => (_jsx("option", { value: c.id, children: c.full_name }, key)))] }) }), _jsx(FormItem, { children: _jsx("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' }, children: _jsx(Button, { size: "l", stretched: true, 
                                        // disabled={!formCreateM}
                                        disabled: !(full_name_menu.iserr === 'valid'
                                            && full_desc_menu.iserr === 'valid'
                                            && price.iserr === 'valid'), onClick: () => {
                                            updateMenu();
                                        }, children: t('save_position') }) }) })] }) : null }), _jsx(ModalPage, { id: 'qr', className: "qrall", onClose: () => setActiveModal(null), dynamicContentHeight: true, 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: t('qr_code') }), children: _jsxs(Div, { children: [_jsx("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' }, children: _jsx("div", { ref: ref, id: "qrcode" }) }), _jsx("br", {}), _jsx("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' }, children: _jsx(Button, { size: "l", stretched: true, onClick: () => {
                                    qrCode.download({
                                        name: `${selectMerhant?.id.toString()}-qrall.ge` ?? 'qr-menu',
                                        extension: 'png'
                                    });
                                }, children: t('download') }) })] }) }), _jsx(ModalPage, { id: 'qr2', className: "qrall", onClose: () => setActiveModal(null), dynamicContentHeight: true, 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: "test" }), children: _jsxs(Div, { children: [_jsx("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' }, children: _jsx("div", { ref: ref, id: "qrcode" }) }), _jsx("br", {}), _jsx("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' }, children: _jsx(Button, { size: "l", stretched: true, onClick: () => {
                                    qrCode.download({
                                        name: `${selectMerhant?.id.toString()}-qrall.ge` ?? 'qr-menu',
                                        extension: 'png'
                                    });
                                }, children: t('download') }) })] }) }), _jsx(ModalPage, { id: 'one_menu', className: "qrall", onClose: () => setActiveModal(null), dynamicContentHeight: true, settlingHeight: 100, header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: oneMenu ? oneMenu.full_name : 'Position' }), children: oneMenu ? _jsxs("div", { children: [_jsx("div", { style: { backgroundImage: `url(${ipfs + oneMenu.img})` }, className: 'img-card2' }), _jsx(Div, { children: _jsxs(Div, { children: [_jsx(Div, { children: oneMenu.full_desc }), _jsx(SimpleCell, { after: `${oneMenu.price} ₾`, children: "Price" })] }) })] }) : null })] }));
    return (_jsx(AppRoot, { children: _jsxs(SplitLayout, { className: "qrall", style: { justifyContent: 'center' }, modal: modalRoot, popout: popout, 
            // header={isDesktop
            //     && <PanelHeader separator={false} className="qrall-ge-header" />
            // }
            header: location.pathname.indexOf('/menu') === -1
                && !loginPage && auth === 2 ? _jsx(HeaderBlock, { userInfo: userInfo, logOut: logOut }) : null, children: [loginPage && auth !== 2 && location.pathname.indexOf('/menu') === -1
                    ? _jsx(LoginPage, { id: "login", isDesktop: isDesktop, setLoginPage: setLoginPage, setAuth: setAuth, loginUser: loginUser })
                    : _jsx("div", { style: {
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%'
                        }, children: _jsx(SplitCol, { animate: false, spaced: isDesktop, width: isDesktop ? '900px' : '100%', maxWidth: isDesktop ? '900px' : '100%', children: _jsx(Epic, { activeStory: 'main', tabbar: !isDesktop && auth === 2 && location.pathname.indexOf('/menu') === -1 && (_jsxs(Tabbar, { children: [_jsx(TabbarItem, { selected: location.pathname === '/restourants', text: "Restourants", onClick: () => history('/restourants'), children: _jsx(Icon28Users3Outline, {}) }), _jsx(TabbarItem, { selected: location.pathname === '/settings', text: "Settings", onClick: () => history('/settings'), children: _jsx(Icon28SettingsOutline, {}) }), _jsx(TabbarItem, { text: "Log out", onClick: () => logOut(), children: _jsx(Icon28DoorArrowRightOutline, {}) })] })), children: _jsxs("div", { id: "main", children: [location.pathname.indexOf('/menu') === -1 ? _jsx(PanelHeader, { className: 'header-full2', before: _jsx("img", { src: "", style: { height: '42px', cursor: 'pointer' }, onClick: () => history('/merchants') }) }) : null, _jsxs(Routes, { children: [_jsx(Route, { path: "/restourants", element: _jsx(View, { activePanel: 'main1', id: "view", children: _jsx(Main, { id: "main1", setActiveModal: setActiveModal, consoleLog: consoleLog, logOut: logOut, getUser: getUser, isDesktop: isDesktop, newApi: newApi, onErrorApi: onErrorApi }) }) }), _jsx(Route, { path: "/restourant/:idMerchant", element: _jsx(View, { activePanel: 'merchant1', id: "view", children: _jsx(Merchant, { id: "merchant1", setActiveModal: setActiveModal, consoleLog: consoleLog, setSelectMerhant: setSelectMerhant, logOut: logOut, isDesktop: isDesktop, newApi: newApi, onErrorApi: onErrorApi, getUser: getUser, setCategoryList: setCategoryList, setOneMenu: setOneMenu }) }) }), _jsx(Route, { path: "/menu/:idMerchant", element: _jsx(View, { activePanel: 'menu1', id: "view", children: _jsx(MenuPage, { id: "menu1", setActiveModal: setActiveModal, consoleLog: consoleLog, setSelectMerhant: setSelectMerhant, logOut: logOut, isDesktop: isDesktop, newApi: newApi, onErrorApi: onErrorApi, getUser: getUser, setCategoryList: setCategoryList, setOneMenu: setOneMenu }) }) }), _jsx(Route, { path: "/settings", element: _jsx(View, { activePanel: 'settings1', id: "view", children: _jsx(Settings, { id: "settings1", setActiveModal: setActiveModal }) }) }), _jsx(Route, { path: "/500", element: _jsx(View, { activePanel: 'error1', id: "view", children: _jsx(Error, { id: "error1", setActiveModal: setActiveModal, text: errorText }) }) })] })] }) }) }) }), snackbar] }) }));
};
